<template>
  <div class="warpper">
    <div class="banner" height="650px">
      <swiper
        :slidesPerView="1"
        :loop="true"
        :autoplay="swiperOptions.autoplay"
        :pagination="true"
        :navigation="swiperOptions.navigation"
        class="swiper-wrapper"
      >
        <swiper-slide v-for="(item, index) in bannerList" :key="index">
          <img :src="item.pcPhoto" alt="" />
        </swiper-slide>
      </swiper>
    </div>
    <section class="box rom">
      <div class="roll" v-if="userInfo.uid > 0 && CouponList.length > 0">
        <!-- <li class="item1">
          <div>先领卷</div>
          <div>在下单</div>
        </li>
        <li class="item2" v-for="(item, index) in 3" :key="index">
          <div class="tag_title">满<em>10</em>元减<em>6</em>元</div>
          <div class="tag_btn">立即领取</div>
        </li> -->
        <div class="item1">
          <div>先领券</div>
          <div>再下单</div>
        </div>
        <swiper
          :slidesPerView="swiperOptions.slidesPerView"
          :loop="false"
          :autoplay="false"
          :pagination="false"
          :navigation="swiperOptions.navigation"
          class="swiper-wrapper"
        >
          <swiper-slide v-for="(item, index) in CouponList" :key="index">
            <div class="item2">
              <div class="tag_title" v-if="item.fullPrice > 0">
                满<em>{{ item.fullPrice }}</em
                >元减<em>{{ item.reducePrice }}</em
                >元
              </div>
              <div class="tag_title" v-else>
                无门槛减<em>{{ item.reducePrice }}</em
                >元
              </div>
              <div class="tag_btn" @click="CouponHandle(item)">立即领取</div>
            </div>
          </swiper-slide>
        </swiper>
      </div>
    </section>
    <section class="box ith">
      <div class="box_class">
        <div class="class_title">全部分类</div>
        <swiper
          :slidesPerView="swiperOptions.slidesPerView"
          :loop="true"
          :slidesPerGroup="3"
          :autoplay="false"
          :pagination="false"
          :navigation="swiperOptions.navigation"
          class="swiper-wrapper"
        >
          <swiper-slide v-for="(item, index) in BigClassList" :key="index">
            <product-item :item="item" />
          </swiper-slide>
        </swiper>
      </div>
    </section>
    <div class="box_banner bn2">
      <img src="../assets/images/banner2.png" alt="" />
    </div>
    <section class="box" v-for="(item, index) in newBornList" :key="index">
      <div class="area_top">
        <div class="area_title">
          {{ item.buildName }}
        </div>
        <div class="rocc_more" @click="moreHandler(item.id)">
          <div>更多</div>
          <div class="rocc_arr"></div>
        </div>
      </div>
      <div class="area_list">
        <div
          class="area_con"
          v-for="(list, index) in item.products"
          :key="index"
          @click="goBtn({ path: '/product/detail', query: { pid: list.id } })"
        >
          <div class="area_img">
            <el-image :src="list.smallPhoto" lazy></el-image>
          </div>
          <div class="item_title">{{ list.name }}</div>
          <div class="area_tag">领券享优惠</div>
          <!-- <div class="area_btn">更多的</div> -->
        </div>
      </div>
    </section>
    <!-- <section class="box">
      <div class="rocc_con">
        <div class="rocc_text">热门推荐</div>
        <div class="rocc_more">
          <div>更多</div>
          <div class="rocc_arr"></div>
        </div>
      </div>
      <ul class="rocc_list">
        <li>
          <img class="like_hear" src="../assets/images/icon9.png" alt="" />
          <img class="like_heard" src="../assets/images/icon10.png" alt="" />
          <div class="rocc_img">
            <img src="../assets/images/rocc1.png" alt="" />
          </div>
          <div class="rocc_title">
            佰草集洁面乳平衡系列洗面奶补水保湿 控油清洁男女学生成人洗面乳
          </div>
        </li>
      </ul>
    </section> -->
  </div>
</template>
<script>
import { Swiper, SwiperSlide } from 'swiper/vue'
import SwiperCore, {
  Autoplay,
  Pagination,
  EffectCoverflow,
  Navigation
} from 'swiper'
import { reactive, onMounted, ref, computed } from 'vue'
import { useStore } from 'vuex'
import productItem from '../components/product_item.vue'
import { getPost, posts } from '../utils/posts'
import { useRouter } from 'vue-router'
import { ElMessage } from 'element-plus'
SwiperCore.use([Autoplay, Pagination, EffectCoverflow, Navigation])
export default {
  name: 'Home',
  components: {
    productItem,
    Swiper,
    SwiperSlide
  },
  setup () {
    const bannerList = ref([])
    const BigClassList = ref([])
    const store = useStore()
    const newBornList = ref([])
    const router = useRouter()
    const userInfo = store.state.userInfo || { uid: 0 }
    const CouponList = ref([])

    // swiper相关配置属性放在swiperOptions这个变量里
    const swiperOptions = reactive({
      autoplay: {
        disableOnInteraction: false, // 鼠标滑动后不自动播放
        delay: 1500 // 1.5秒切换一次
      },
      speed: 500, // 切换过渡速度
      loop: true,
      slidesPerView: '3', // 解决最后一张切换到第一张中间的空白
      centeredSlides: true, // 设置slide居中
      spaceBetween: 20,
      coverflowEffect: {
        // rotate: 0, //slide做3d旋转时Y轴的旋转角度。默认50。
        stretch: 50, // 每个slide之间的拉伸值（距离），越大slide靠得越紧。 默认0。
        depth: 100, // slide的位置深度。值越大z轴距离越远，看起来越小。 默认100。
        modifier: 1 // depth和rotate和stretch的倍率，相当于depth*modifier、rotate*modifier、stretch*modifier，值越大这三个参数的效果越明显。默认1。
        // slideShadows: false, //开启slide阴影。默认 true。
      },
      navigation: {
        nextElRef: '.swiper-button-next swiper-button-black',
        prevElRef: '.swiper-button-prev swiper-button-black'
      },
      pagination: {
        clickable: true
      }
    })
    const onSwiper = (swiper) => {
      console.log(swiper)
    }
    const onSlideChange = () => {
      console.log('slide change')
    }
    // 新人专区
    const newBornHandler = () => {
      getPost('product/build/' + userInfo.uid).then((res) => {
        newBornList.value = res.data
      })
    }
    const goBtn = (obj) => {
      router.push(obj)
    }
    // 优惠卷显示
    const user = computed(() => {
      return store.state.userInfo || { uid: 0 }
    })
    // 获取大类
    const BigClassHandler = () => {
      posts('classes/getBigClassWithProductCount/' + userInfo.uid).then(
        (res) => {
          BigClassList.value = res.data
        }
      )
    }
    // 广告图
    const getBanner = () => {
      getPost('banner/get').then((res) => {
        bannerList.value = res.data
      })
    }
    // 获取优惠卷
    const publicCouponHandle = () => {
      posts('coupon/publicCoupon/' + userInfo.uid).then((res) => {
        CouponList.value = res.data
      })
    }
    // 领取优惠卷
    const CouponHandle = (val) => {
      posts('coupon/receive/' + userInfo.uid, { couponId: val.id }).then(
        (res) => {
          ElMessage({
            showClose: true,
            message: res.msg,
            type: 'success'
          })
          publicCouponHandle()
        }
      )
    }
    // 更多
    const moreHandler = (id) => {
      router.push({ path: '/search/index', query: { buildId: id } })
    }
    onMounted(() => {
      getBanner()
      BigClassHandler()
      newBornHandler()
      publicCouponHandle()
    })
    return {
      moreHandler,
      CouponList,
      CouponHandle,
      publicCouponHandle,
      userInfo,
      goBtn,
      newBornList,
      newBornHandler,
      user,
      BigClassHandler,
      BigClassList,
      bannerList,
      onSwiper,
      onSlideChange,
      swiperOptions
    }
  }
}
</script>
<style lang="scss">
// .warpper .banner .swiper-button-prev {
//   left: 70px;
// }
// .warpper .banner .swiper-button-next {
//   right: 70px;
// }
.homePage {
  width: auto;
}
.box_banner {
  margin: 50px 0 0 0;
  width: 1200px;
  height: 215px;
  overflow: hidden;
  img {
    width: 100%;
    height: 100%;
  }
  &.bn2 {
    padding: 0 12px;
  }
}
.banner {
  width: 1200px;
  height: 344px;
  box-sizing: border-box;
  margin: 50px 0 0 0;
  img {
    width: 100%;
    height: 100%;
  }
}
.box {
  width: 1200px;
  margin: 50px 0 0 0;
  &.ith {
    margin: 20px 0 0 0;
  }
  &.rom {
    margin: 50px 0 0 0;
  }
  .area_top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 14px;
    .rocc_more {
      font-size: 18px;
      font-weight: 400;
      line-height: 24px;
      color: #b4b4b5;
      margin: 0 0 24px 0;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      .rocc_arr {
        width: 8px;
        height: 9px;
        background: url(../assets/images/icon13.png) no-repeat;
      }
      div {
        padding: 0 8px 0 0;
      }
    }
  }
  .rocc_con {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .rocc_text {
      font-size: 34px;
      font-weight: 600;
      color: #211613;
      margin: 0 0 24px 0;
    }
  }
  .rocc_list {
    display: flex;
    justify-content: space-between;
    li {
      width: 280px;
      height: 340px;
      background: white;
      border-radius: 8px;
      padding: 15px 15px 0 15px;
      display: flex;
      flex-direction: column;
      align-items: center;
      position: relative;
      margin: 0 0 16px 0;
      .like_hear {
        position: absolute;
        top: 0px;
        right: 6px;
        width: 49px;
      }
      .like_heard {
        position: absolute;
        top: 42px;
        right: 6px;
        width: 49px;
      }
      .rocc_title {
        margin: 16px 0 0 0;
        line-height: 22px;
        text-overflow: ellipsis;
        color: #3e3a39;
      }
    }
  }
  .area_list {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    overflow: hidden;
    .area_con {
      width: 270px;
      background: white;
      border-radius: 8px;
      padding: 15px 15px 15px 15px;
      margin: 15px;
      display: flex;
      flex-direction: column;
      align-items: center;
      cursor: pointer;
      transition: all 0.3s ease 0s;
      &:hover {
        transform: scale(1.01);
      }
      .area_img {
        height: 240px;
        width: 240px;
        overflow: hidden;
      }
      .area_btn {
        width: 72px;
        height: 24px;
        line-height: 24px;
        text-align: center;
        color: white;
        background: linear-gradient(90deg, #ff5e41 0%, #fc4353 100%);
        opacity: 1;
        border-radius: 4px;
        margin: 24px 0 0 0;
        font-size: 14px;
        cursor: pointer;
      }
      .area_tag {
        font-size: 14px;
        font-weight: 400;
        color: #cccccc;
        margin: 12px 0 0 0;
      }
      .item_title {
        width: 100%;
        height: 25px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        margin: 16px 0 0 0;
        color: #3e3a39;
        font-size: 18px;
      }
    }
  }

  .area_title {
    font-size: 34px;
    font-weight: 600;
    color: #211613;
    margin: 0 0 10px 0;
  }
  .box_class {
    display: flex;
    flex-direction: column;
    .class_title {
      font-size: 34px;
      font-weight: 600;
      color: #211613;
      margin: 0 0 24px 0;
      padding: 0 0 0 8px;
    }
  }
  .roll {
    display: flex;
    align-items: center;
    .item2 {
      width: 344px;
      height: 212px;
      background: url(../assets/images/roll2.png);
      background-position: center;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      .tag_btn {
        width: 120px;
        height: 36px;
        background: linear-gradient(90deg, #ff5e41 0%, #fc4353 100%) no-repeat;
        opacity: 1;
        border-radius: 18px;
        text-align: center;
        line-height: 36px;
        color: white;
        font-size: 18px;
        margin: 16px 0 0 0;
        cursor: pointer;
      }
      .tag_title {
        font-size: 34px;
        em {
          color: red;
        }
      }
    }
    .item1 {
      width: 204px;
      height: 212px;
      margin: 0 2px 0 8px;
      background: url(../assets/images/roll1.png) no-repeat;
      background-position: center;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      font-size: 34px;
      box-sizing: border-box;
      div {
        margin: 10px 0;
      }
    }
  }
}
</style>
